import { isString } from 'lodash';

// Update this number if you modify the number of generic avatars in the /client/app/components/bc-svg-symbols/symbol-avatars/symbol-avatars.component.html file.
export const GENERIC_AVATAR_COUNT = 90;
export const THEME_COUNT = 24;

export class ThemeServiceHelper {
  /**
   * Returns the name of the CSS class of the theme for the specified work item.
   * @param {string | number} itemId - The unique identifier of the e-mail or chat item for what the theme class should be returned.
   * @param {boolean} [isSelected] - Determines whether the returned theme should indicate that the item is selected.
   * @param {boolean} [isNew] - Determines whether the returned theme should indicate that the item is unprocessed.
   * @param {boolean} isOpened - Adds opened class if set to true
   * @param {boolean} isClosed - Adds closed class if set to true
   * @param {boolean} isIdle - Add idle class if set to true
   * @returns {string} - The name of the CSS class of the theme for the specified work item.
   * @throws {Error} - If itemId is not specified.
   */
  static getCssClass(itemId: string | number, isSelected?: boolean, isNew?: boolean, isOpened?: boolean, isClosed?: boolean, isIdle?: boolean): string {
    if (!itemId) {
      throw new Error('Please specify to item ID!');
    }

    let classStr = '';

    if (isSelected) {
      classStr += 'focus ';
    }

    const themeId = this.getThemeId(itemId);

    classStr += `${this.getThemeCssClassName(themeId)} `;

    if (isNew) {
      classStr += 'new-item ';
    }

    if (isOpened) {
      classStr += 'opened ';
    }

    if (isClosed) {
      classStr += 'closed ';
    }

    if (isIdle) {
      classStr += 'idle ';
    }

    return classStr;
  }

  static getThemeCssClassName(themeId: number): string {
    return `theme-${themeId}`;
  }

  static getAvatarThemeId(itemId: number | string): number {
    if (!itemId) {
      throw new Error('Please specify to item ID!');
    }

    return this.getThemeId(itemId, GENERIC_AVATAR_COUNT);
  }

  static getThemeId(itemId: number | string, themeCount = THEME_COUNT): number {
    if (!itemId) {
      throw new Error('Please specify to item ID!');
    }

    let idNumber: number = isString(itemId) ? Math.abs(this.getStringHashCode(itemId)) : itemId;

    // Because workitem-, chat- and e-mail IDs can be longer than the maximum length of an integer that JavaScript can handle,
    // we use only N number of characters to ensure they can be safely used in mathematical operations.
    // We use the last N number of characters, because they have larger deviation.
    const SEED_MAX_LENGTH = 14;    // The maximum number of characters to use from the itemId.
    const strItemId = '' + idNumber; // Convert number parameter to string.
    const strSeed: string = strItemId.length > SEED_MAX_LENGTH
      ? strItemId.substr(strItemId.length - SEED_MAX_LENGTH, SEED_MAX_LENGTH)
      : strItemId;
    const seed: number = +strSeed;

    // The number of color themes defined in the /node_modules/@bold/assets/scss/helpers/_color-maps.scss file.
    const THEME_COUNT: number = themeCount;

    const themeId: number = seed % THEME_COUNT + 1;

    return themeId;
  }

  private static getStringHashCode(value: string): number {
    let hash = 0;
    for (let i = 0; i < value.length; i++) {
    // eslint-disable-next-line no-bitwise
      hash = Math.imul(31, hash) + value.charCodeAt(i) | 0;
    }
    return hash;
  }
}
